import service from '@/services/admin/role'

// import { Session } from '@/plugins/session'

const getDefaultState = () => ({
  session: null,
  role: {
    name: '',
    events: []
  },
  events: [],
  list: [],
  pageInfo: {},
  currentRow: null,
  saved: null
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.role = getDefaultState().role),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_ROLE: (state, obj) => {
    state.role = obj
    state.saved = true
  },
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  SET_EVENT_LIST: (state, objs) => {
    state.events = objs
  },
  SET_DEFAULT_EVENTS: state => {
    state.role.events = state.events.map(e => ({ ...e, group: e.group.map(g => ({ ...g, check: false })) }))
  },
  DELETE_LIST: (state, obj) => {
    state.list = state.list.filter(e => e._id !== obj._id)
  },
  SAVE_CHANGES: (state, obj) => {
    state.role = obj
    state.saved = false
  }
}

export const actions = {
  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },
  readAllByEmisor: async ({ commit, state, rootGetters }, { restart = false, limit = 10 }) => {
    if (restart) await dispatch('resetList')

    if (state.list.length) {
      return state.list
    }

    return service.readAllByEmisor(await rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit).then(response => {
      console.log('Roles from server 🤖')

      return commit('SET_LIST', response)
    })
  },

  readAllEvents: ({ commit, state }) => {
    if (!state.events.length) service.readAllEvents().then(response => commit('SET_EVENT_LIST', response))
  },

  readById: async ({ commit }, _id) => service.readById(_id).then(response => commit('SET_ROLE', response)),

  create: async ({ commit, rootGetters }, input) => {
    delete input.createdAt
    delete input.updatedAt

    return service
      .create({
        ...input,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => commit('UPDATE_LIST', { ...input, _id: result._id }))
  },

  delete: ({ commit }, items) =>
    service.delete(items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', i)
      })
      return result
    })
}
